<template>
  <section class="section-cinemaDetails">
    <div class="container">
      <div class="section-space-50 d-none d-md-block"></div>
      <!-- INTRO ROW -->
      <div class="row">
        <div
          class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 order-2 order-md-1"
        >
          <div class="d-none d-md-block">
            <h3 class="mb-1">{{ cinema && cinema.Cinema_strName }}</h3>
            <div class="text-muted mb-3">
              {{ cinema && cinema.cinema_address }}
            </div>
          </div>
          <p class="py-3 py-md-0 movie-details-text">
            {{ cinema && cinema.cinema_description }}
          </p>

          <div class="mb-3 infoTabs">
            <div
              class="detail-header py-1 px-2 cursor-pointer"
              v-b-toggle.collapse-1
            >
              <img
                src="@/assets/img/icons/shield-alt-solid.svg"
                height="20px"
                width="20px"
                class="mr-1"
                alt=""
              />
              My Safety First
              <span class="mr-2">
                <img
                  src="@/assets/img/icons/down-arrow.svg"
                  height="10px"
                  width="10px"
                  alt=""
                />
              </span>
            </div>
            <b-collapse id="collapse-1" class="mt-2">
              <b-card class="p-0">
                <ul class="list-inline mb-0">
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_thermal_scanning"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Thermal Scanning
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_contactless_security"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Contactless Security Check
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_sanitizers"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Hand Sanitizers Available
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_sanitization"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Sanitization Before Every Show
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_social_distancing"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      In-Cinema Social Distancing
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_contactless_food"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Contactless Food Service
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_packaged_food"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Packaged Food and Beverages
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_daily_temperature"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Daily Temperature Checks for Staff
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_deep_cleaning"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Deep Cleaning of Restrooms
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_limited_occupancy"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Limited Occupancy in Restrooms
                    </div>
                  </li>
                  <li
                    class="list-inline-item mb-2"
                    v-if="cinema && cinema.cinema_has_sanitized_glasses"
                  >
                    <div class="fs-12 py-1 px-3 bg-light rounded">
                      Sanitized / Sterlized 3D Glasses
                    </div>
                  </li>
                </ul>
              </b-card>
            </b-collapse>
          </div>

          <div class="mb-3 infoTabs">
            <div
              class="detail-header py-1 px-2 cursor-pointer"
              v-b-toggle.collapse-2
            >
              <img
                src="@/assets/img/icons/shield-alt-solid.svg"
                height="20px"
                width="20px"
                class="mr-1"
                alt=""
              />
              Available Facilities
              <span class="mr-2">
                <img
                  src="@/assets/img/icons/down-arrow.svg"
                  height="10px"
                  width="10px"
                  alt=""
                />
              </span>
            </div>
            <b-collapse id="collapse-2" class="mt-2">
              <b-card class="p-0 border-0">
                <div class="pt-2 facilities-list">
                  <div class="icon-box" v-if="cinema && cinema.cinema_has_fnb">
                    <div>
                      <i class="fas fa-utensils"></i>
                    </div>
                    <div>
                      <div class="small text-box">F&amp;B</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_mticket"
                  >
                    <div>
                      <i class="fas fa-mobile-alt"></i>
                    </div>
                    <div>
                      <div class="small text-box">M-Ticket</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_parking"
                  >
                    <div>
                      <i class="fas fa-parking"></i>
                    </div>
                    <div>
                      <div class="small text-box">Parking</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_chefs_corner"
                  >
                    <div>
                      <img
                        src="@/assets/img/icons/dining.svg"
                        height="20px"
                        width="20px"
                        alt=""
                      />
                    </div>
                    <div>
                      <div class="small text-box">Chef's Corner</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_maximum"
                  >
                    <div>
                      <i class="fas fa-desktop"></i>
                    </div>
                    <div>
                      <div class="small text-box">
                        Maximum - <br />Large Screen Format
                      </div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_dolby_atmos"
                  >
                    <div>
                      <img
                        src="@/assets/img/icons/dolby.svg"
                        height="20px"
                        width="20px"
                        alt=""
                      />
                    </div>
                    <div>
                      <div class="small text-box">Dolby Atmos</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_book_now_pay_later"
                  >
                    <div>
                      <i class="fas fa-rupee-sign"></i>
                    </div>
                    <div>
                      <div class="small text-box">
                        Book Now, <br />
                        Pay Later
                      </div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_ticket_cancellation"
                  >
                    <div>
                      <i class="fas fa-ticket-alt"></i>
                    </div>
                    <div>
                      <div class="small text-box">Ticket Cancellation</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_recliners"
                  >
                    <div>
                      <i class="fas fa-couch"></i>
                    </div>
                    <div>
                      <div class="small text-box">Recliners</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_laser_projection"
                  >
                    <div>
                      <i class="fas fa-film"></i>
                    </div>
                    <div>
                      <div class="small text-box">Laser Projection</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_kids_zone"
                  >
                    <div>
                      <i class="fas fa-child"></i>
                    </div>
                    <div>
                      <div class="small text-box">Kids Zone</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_wheelchair"
                  >
                    <div>
                      <i class="fas fa-wheelchair"></i>
                    </div>
                    <div>
                      <div class="small text-box">Wheelchair Access</div>
                    </div>
                  </div>

                  <div
                    class="icon-box"
                    v-if="cinema && cinema.cinema_has_open_cafe"
                  >
                    <div>
                      <i class="fas fa-coffee"></i>
                    </div>
                    <div>
                      <div class="small text-box">Open Cafe</div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
        <div
          class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 order-1 order-md-2 px-0 px-md-3 movie-detail-page-overlay"
        >
          <!-- IMAGE SECTION -->
          <div class="d-none">
            <img
              v-lazy="
                cinema && cinema.image_path_1
                  ? IMAGE_URL + cinema.image_path_1
                  : null
              "
              class="img-fluid rounded shadow w-100 movie-detail-page-top-img"
              alt
            />

            <div class="md-overlay-text d-md-none">
              <p class="md-title mb-1">
                {{ cinema && cinema.Cinema_strName }}
              </p>
              <p class="md-text mb-0">{{ cinema && cinema.cinema_address }}</p>
            </div>
          </div>

          <!-- VIDEO SECTION -->
          <div class="" v-if="cinema && cinema.cinema_video_path">
            <video width="100%" height="auto" controls>
              <source
                :src="
                  cinema &&
                  cinema.cinema_video_path &&
                  IMAGE_URL + cinema.cinema_video_path
                "
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
          <div v-if="cinema && !cinema.cinema_video_path">
            <slick>
              <div v-for="(data, index) in cinemaImages" :key="index">
                <img
                  v-lazy="IMAGE_URL + data"
                  class="img-fluid rounded shadow w-100 movie-detail-page-top-img"
                  alt
                />
              </div>
            </slick>
            <div v-if="cinemaImages.length == 0">
              <img
                v-lazy="
                  cinema && cinema.image_path_1
                    ? IMAGE_URL + cinema.image_path_1
                    : null
                "
                class="img-fluid rounded shadow w-100 movie-detail-page-top-img"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section-space-50 d-none d-md-block"></div>

      <!-- SELECT SHOW DATE COMPONENT -->
      <selectShowDate
        @onChangeDate="onHandleDateSelect"
        :movie_date="selectedDate"
        :dates="dates"
      />

      <div class="section-space-25 d-none d-md-block"></div>

      <!-- MOVIE LISTING ROW -->
      <div class="row">
        <div
          class="col-12"
          :key="cinemaShowKey"
          v-for="(cinemaShows, cinemaShowKey) in sessions"
        >
          <div
            class="cinema-show-detail"
            :class="window.width < 767 ? 'py-3' : ''"
          >
            <div
              class="legends-container mb-4 d-flex align-items-center justify-content-end"
            >
              <div class="showtimes-legend">
                <div class="legend-icon"></div>
                <div class="legend-text">Available</div>
              </div>
              <div class="showtimes-legend">
                <div class="legend-icon fast"></div>
                <div class="legend-text">Fast Filling</div>
              </div>
              <div class="showtimes-legend">
                <div class="bn_subtitle mr-2">LAN</div>
                <div class="legend-text">Subtitles Language</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-3 mb-md-0">
                <img
                  v-lazy="
                    cinemaShows && cinemaShows.image_path_1
                      ? IMAGE_URL + cinemaShows.image_path_1
                      : null
                  "
                  class="img-fluid d-none d-md-block cinema-show-detail-img"
                  alt
                />
                <div class="cinema-show-sm-content">
                  <div class="cinema-show-title font-weight-bold">
                    {{ cinemaShows.name }}
                  </div>
                  <ul class="dot-list">
                    <li>{{ cinemaShows.language_name }}</li>
                    <li>{{ cinemaShows.genre_name }}</li>
                    <li>{{ cinemaShows.Film_strCensor }}</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-9">
                <div
                  class="row mx-0"
                  v-for="(sLoop, sLoopKey) in 1"
                  :key="sLoopKey"
                >
                  <!-- <div class="col-3 col-md-2">
                    <ul class="showtime-inline-list has-format">
                      <li>
                        <span>3D</span>
                      </li>
                    </ul>
                  </div>-->
                  <div class="col-9 col-md-10 pl-0 pl-md-3">
                    <ul class="showtime-inline-list">
                      <li
                        v-for="(showtimes, showtimesKey) in cinemaShows.timing"
                        :key="showtimesKey"
                        :class="
                          showtimes.seats_available_for_sale >
                          (fast_filling_percentage / 100) *
                            showtimes.total_seats_available
                            ? 'text-success'
                            : showtimes.seats_available_for_sale === 0
                            ? 'text-danger disable'
                            : showtimes.seats_available_for_sale <
                              (fast_filling_percentage / 100) *
                                showtimes.total_seats_available
                            ? 'text-rose-gold'
                            : ''
                        "
                        @click="
                          showtimes.seats_available_for_sale > 0 &&
                            $router.push({
                              name: 'Seat Layout',
                              params: {
                                session_id: showtimes.id,
                                cinema_code: cinema.Cinema_strID,
                              },
                            })
                        "
                      >
                        {{ showtimes.time | timeparse }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-space-50"></div>
    </div>

    <!-- BOOK FOOTER FOR MOBILE -->
    <!-- Note: Add class 'disabled' to disabled button(also it will automatically disabled click event)-->
    <!-- <div class="mobile-footer d-md-none">BOOK</div> -->
  </section>
</template>

<script>
import selectShowDate from "@/components/partials/selectShowDate";
import CinemaService from "@/apiServices/CinemaService";
import moment from "moment";
import Vue from "vue";
import { IMAGEURL } from "@/config";
import { C } from "caniuse-lite/data/agents";
export default {
  data() {
    return {
      fast_filling_percentage: null,
      IMAGE_URL: IMAGEURL,
      cinema: null,
      cinemaImages: [],
      selectedDate: null,
      sessions: [],
      timings: [],
      dates: [],
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  components: {
    selectShowDate,
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  async beforeMount() {
    const { cinema_code } = this.$route.params;

    if (this.$route.query.S != undefined) {
      localStorage.source = this.$route.query.S;
    } else {
      localStorage.removeItem("source");
    }

    if (cinema_code) {
      this.selectedDate = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
      await this.getCinema(cinema_code, this.selectedDate);
      if (this.dates.length > 0) {
        this.onHandleDateSelect({ event: null, date: this.dates[0] });
      }
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    onHandleDateSelect({ event, date }) {
      const { cinema_code } = this.$route.params;
      this.selectedDate = date;
      this.getCinema(cinema_code, date);
    },
    async getCinema(cinema_code, date) {
      console.log("getCinema -> date", date);

      let loader = Vue.$loading.show();
      try {
        this.cinema = null;
        this.sessions = [];
        const response = await CinemaService.GetCinema({ cinema_code, date });
        const { data } = response;
        if (data && data.status) {
          console.log("Cinema Data", data.data);
          this.cinema = data.data.cinemaDetails;
          for (let i = 1; i < 10; i++) {
            if (this.cinema[`image_path_${i}`] != null) {
              this.cinemaImages.push(this.cinema[`image_path_${i}`]);
            }
          }
          console.log("Cinema Images", this.cinemaImages);
          this.fast_filling_percentage = data.data.cinemaDetails.fast_filling;
          this.sessions = data.data.sessionDetails;
          const timing = Array();
          this.sessions.forEach((sess) => {
            this.timings.push(sess.timing);
          });
          this.dates = data.data.dateDetails;
          // if (this.dates.length > 0) {

          // }
        }
      } catch (error) {
        console.error(error);
      } finally {
        loader.hide();
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>
<style>
/* .facilities-list .icon-box {
  
} */
.facilities-list .text-box {
  line-height: 1;
}

.facilities-list .icon-box:not(:last-child) {
  /* margin-right: 0.5rem; */
}
.facilities-list .icon-box div {
  margin-bottom: 5px;
  /* min-height: 30px; */
}
.facilities-list .icon-box {
  text-align: center;
}
.facilities-list .icon-box .fas {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/cinemaDetails.vue